import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {
  WmsDialogBodyComponent,
  WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent,
  WmsMessageComponent
} from '@wms/app/components';
import { BaseComponent } from '../../../../components/base/base.component';
import { DialogService, PrefabService } from '@wms/app/services';
import { forEach, get, indexOf, pull } from 'lodash-es';
import { CommonModule } from '@angular/common';
import { PrefabManager } from '@wms/app/workspace/page-workspace/prefabs/prefab-manager';

@Component({
  selector: 'wms-prefab-confict-dialog',
  templateUrl: './prefab-confict-dialog.component.html',
  styleUrls: ['./prefab-confict-dialog.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent
  ],
})
export class PrefabConfictDialogComponent extends BaseComponent{

  conflictPrefabs: any;
  prefabName: string;
  prefabDetails:any;
  message:any
  constructor(private prefabManager: PrefabManager,private dialogService: DialogService, private prefabService: PrefabService) {
    super();
  }
  ngOnInit() {
    const dialogObject = this.dialogService.dialogs.find(dialog => dialog.id === 'prefabConflictDialog');
    this.prefabDetails = dialogObject.dialogParams.resolve.dialogParams();
    let errObj = this.prefabDetails.error,
      errorMsg,
      startIndex,
      endIndex;
    this.conflictPrefabs =
      get(errObj, 'errors.error[0].parameters') || [];
    this.prefabName = this.conflictPrefabs.shift();
    if (!this.conflictPrefabs.length) {
      // extracting the error details obj from message if there are no parameters
      errorMsg = get(errObj, 'errors.error[0].message');
      startIndex = errorMsg.indexOf('[');
      endIndex = errorMsg.lastIndexOf(']');
      this.conflictPrefabs = errorMsg.substring(startIndex, endIndex + 1);
      this.prefabName = this.prefabDetails.prefabName;
    }
    // conflictPrefabs is a stringify json.
    this.conflictPrefabs = JSON.parse(this.conflictPrefabs);
    forEach(this.conflictPrefabs, function (conflictObj) {
      let conflictPrefabName = conflictObj.prefabName,
        hasCurrentProjConflict =
          indexOf(conflictObj.usedBy, conflictPrefabName) !== -1; // if the current prefab is conflicting.

      // remove current prefab name from the conflict prefab list.
      pull(conflictObj.usedBy, conflictPrefabName);
      if (hasCurrentProjConflict) {
        conflictObj.isUsedByProject = true;
      }
  conflictObj.usedByPrefabs = conflictObj.usedBy.join(', ');
    });
  }

  closeDialog() {
    this.dialogService.close('prefabConflictDialog');
  }
  onForceRegister() {
    this.message = {
      type: 'loading',
      caption: this.locale.MESSAGE_PROGRESS_PREFAB_UPGRADE
  };
    if(this.prefabDetails.pushToProj){
      const projectDetails = this.projectService.getDetails();
      const data = {
        targetProjectId: this.prefabDetails.projectId,
        prefabName: projectDetails.name,
        version: projectDetails.version,
    };
      this.prefabService.updatePrefabs('true', data, projectDetails.id)
      .then(() => {
        this.prefabDetails.forceRegisterSuccess(this.prefabDetails.prefabConfig)
        this.closeDialog();
      });
    }
      this.prefabManager.forceRegisterPrefab(
        this.prefabName,
        this.cbPrefabRegistration.bind(this),
        true,
        this.prefabDetails.versionId
      );

  }

  cbPrefabRegistration(response?: any) {
    // response comes only in failure case.
    if (response) {
      this.skipConflict();
    } else {
      this.prefabDetails.forceRegisterSuccess(this.prefabDetails.prefabConfig)
      this.closeDialog();
    }
  }

  skipConflict(){
    this.prefabDetails.onOk()
    this.closeDialog();
  }

}
